export const arrayMove = <T>(arr: T[], fromIndex: number, toIndex: number) => {
    return arrayMoveImmutable(arr, fromIndex, toIndex);
};

export function arrayMoveMutable(array, fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;
    let endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

    endIndex = endIndex > array.length ? array.length : endIndex;

    if (startIndex >= 0 && startIndex < array.length) {
        const [item] = array.splice(startIndex, 1);
        array.splice(endIndex, 0, item);
    }
}

export function arrayMoveImmutable(array, fromIndex, toIndex) {
    const newArray = [...array];
    arrayMoveMutable(newArray, fromIndex, toIndex);
    return newArray;
}
